import types from '@/vuex/caixa-postal/actions-types'
import documentos from '@/utils/documentos'
import dates from '@/utils/dates'

const actions = {
  [types.SET_NUMERO_DOCUMENTO]: async ({ commit }, payload) => { commit(types.SET_NUMERO_DOCUMENTO, payload) },
  [types.SET_ID_TIPO_DOCUMENTO]: async ({ commit }, payload) => { commit(types.SET_ID_TIPO_DOCUMENTO, payload) },
  [types.SET_ID_UNIDADE_ATUAL]: async ({ commit }, payload) => { commit(types.SET_ID_UNIDADE_ATUAL, payload) },
  [types.SET_DATA_ENVIO_INICIO]: async ({ commit }, payload) => { commit(types.SET_DATA_ENVIO_INICIO, payload) },
  [types.SET_DATA_ENVIO_FIM]: async ({ commit }, payload) => { commit(types.SET_DATA_ENVIO_FIM, payload) },
  [types.SET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => { commit(types.SET_LISTA_DOCUMENTOS, payload) },

  [types.GET_LISTA_TIPOS_DOCUMENTOS]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, {root: true})
    try {
      const response = await documentos.getTodosTiposDocumento()
      commit(types.SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data })
    } catch (error) {
      if (error.status === 400) commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Parâmetros de busca inválidos ao buscar lista de tipos de documento' }, {root: true})
      else commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, {root: true})
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, {root: true})
    }
  },

  [types.GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades autorizadas' }, {root: true})
    try {
      const response = await documentos.getListaUnidadesProcedenciaCaixaPostal()
      commit(types.SET_LISTA_UNIDADES_AUTORIZADAS, { listaUnidadesAutorizadas: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as unidades autorizadas' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades autorizadas' }, {root: true})
    }
  },

  [types.INICIALIZAR_FORMULARIO_CAIXA_POSTAL]: async ({ commit, dispatch }) => {
    try {
      let promises = []
      promises.push(dispatch(types.GET_LISTA_TIPOS_DOCUMENTOS))
      promises.push(dispatch(types.GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS))
      await Promise.all(promises)
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.statusText }, {root: true})
      throw error
    }
  },

  [types.GET_DOCUMENTO_CAIXA_POSTAL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento na caixa postal' }, {root: true})
    try {
      const parameters = { numeroDocumento: payload.documento.numeroDocumento ? payload.documento.numeroDocumento : payload.documento.numero }
      const response = await documentos.getListaDocumentosCaixaPostal(parameters)
      const listaFiltrada = response.data.filter(item => item.idDocumento === payload.documento.idDocumento)
      if (listaFiltrada.length > 0) return listaFiltrada[0]
      else return null
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Não foi possível buscar o documento ${payload.documento.numeroDocumento} na sua caixa postal` }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento na caixa postal' }, {root: true})
    }
  },

  [types.GET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    if (!payload.dataEnvioInicio && !payload.dataEnvioFim && !payload.numeroDocumento) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos o número do documento ou então as datas inicial e final conjuntamente' }, {root: true})
      throw new Error('Defina pelo menos o número do documento ou então as datas inicial e final conjuntamente')
    } else if ((payload.dataEnvioInicio && !payload.dataEnvioFim) || (!payload.dataEnvioInicio && payload.dataEnvioFim)) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data, é necessário selecionar tanto a data inicial quanto a data final' }, {root: true})
      throw new Error('Ao selecionar uma data, é necessário selecionar tanto a data inicial quanto a data final')
    } else {
      try {
        commit(types.SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL, {buscandoDocumentosCaixaPostal: true})
        const response = await documentos.getListaDocumentosCaixaPostal(payload)
        let items = response.data
        const length = items.length
        for (let i = 0; i < length; i++) {
          items[i].prazo = dates.daysDiff(items[i].dataEnvio)
          if (items[i].estado && items[i].estado['32002'] === 3) {
            items[i].tipoDocumento = items[i].tipoDocumento + ' (Digitalizado)'
          }
        }
        return items.filter(item => item.estado && (!item.estado['32007'] || item.estado['32007'] === 1))
      } catch (error) {
        if (error.status === 0) commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Tempo de espera expirou. Tente refinar mais sua busca para obter um número menor de resultados.' }, {root: true})
        else commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, {root: true})
        throw error
      } finally {
        commit(types.SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL, {buscandoDocumentosCaixaPostal: false})
      }
    }
  },

  [types.GET_ULTIMA_TRAMITACAO]: async ({ commit }, payload) => {
    if (payload.props.item.dataValidade) {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, {root: true})
      try {
        const response = await documentos.getUltimaTramitacao(payload.props.item.idDocumento)
        payload.props.item.ultimaTramitacao = response.data
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar informações da última tramitação' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, {root: true})
      }
    }
  }
}

export default actions
